import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPhotoCameraFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.326 3.25C8.70363 3.25 8.1279 3.58034 7.81432 4.11784L6.56942 6.25H5C3.48079 6.25 2.25 7.48079 2.25 9V18C2.25 19.5192 3.48079 20.75 5 20.75H19C20.5192 20.75 21.75 19.5192 21.75 18V9C21.75 7.48079 20.5192 6.25 19 6.25H17.4242L16.1297 4.09749L16.1292 4.09656C15.8127 3.57197 15.2443 3.25 14.63 3.25H9.326ZM9.77106 10.6981C11.0352 9.434 13.0847 9.434 14.3489 10.6981C15.613 11.9623 15.613 14.0118 14.3489 15.2759C13.0847 16.5401 11.0352 16.5401 9.77106 15.2759C8.50694 14.0118 8.50694 11.9623 9.77106 10.6981ZM8.7104 9.63747C10.5603 7.78755 13.5596 7.78755 15.4095 9.63747C17.2594 11.4874 17.2594 14.4867 15.4095 16.3366C13.5596 18.1865 10.5603 18.1865 8.7104 16.3366C6.86049 14.4867 6.86049 11.4874 8.7104 9.63747Z",
		fill: "#111827"
	})
});
const ForwardRef = forwardRef(SvgPhotoCameraFilled);
export default ForwardRef;
